import { notificationBlocks, notificationPlainText } from '@/lib/notificationText'

type Props = {
  body: string
  /** Başlık ve adım numaralarının aldığı vurgu rengi. */
  accentClass?: string
}

/**
 * Bildirim gövdesini kart ve geçmiş panelinde aynı biçimde gösterir.
 *
 * Girdi düz metindir. Yeni bildirimler backend'de zaten sadeleştirilir; geçmiş
 * kayıtlarında kalan ham Markdown burada tekrar temizlenir, böylece eski
 * kayıtlar da `###` ve `**` yığını olarak görünmez.
 */
export default function NotificationBody({ body, accentClass = 'text-panel-accent' }: Props) {
  return (
    <>
      {notificationBlocks(notificationPlainText(body)).map((block, index) => {
        if (block.kind === 'gap') return <div key={index} className="h-2" />
        if (block.kind === 'heading') return (
          <p key={index} className={`mt-2 text-[12px] font-semibold ${accentClass}`}>{block.text}</p>
        )
        if (block.kind === 'bullet') return (
          <p key={index} className={`flex gap-2 py-0.5 ${block.nested ? 'pl-4' : 'pl-1'}`}>
            <span aria-hidden="true" className="select-none text-panel-muted">•</span>
            <span className="min-w-0 flex-1 whitespace-pre-wrap">{block.text}</span>
          </p>
        )
        if (block.kind === 'step') return (
          <div key={index} className="my-1.5 rounded-xl border border-panel-border bg-panel-bg px-3 py-2">
            <p className="flex gap-2">
              <span aria-hidden="true" className={`shrink-0 font-semibold ${accentClass}`}>{block.marker}.</span>
              <span className="min-w-0 flex-1 font-semibold whitespace-pre-wrap">{block.text}</span>
            </p>
            {block.details.length > 0 && (
              <p className="mt-1 flex flex-wrap gap-x-3 gap-y-1 text-panel-muted">
                {block.details.map((detail, detailIndex) => <span key={detailIndex}>{detail}</span>)}
              </p>
            )}
          </div>
        )
        return <p key={index} className="whitespace-pre-wrap py-1">{block.text}</p>
      })}
    </>
  )
}
